import { CommonUIError } from '@afterpay/types'
import { APIOptions } from '@googlemaps/js-api-loader'
import { IconNames, InputIconPositions, InputOnFocus, InputSizes } from '..'

export interface InputAddressLoaderOptions extends APIOptions {
  /**
   * @deprecated Use `key` instead. Will be removed in a future version.
   */
  apiKey?: string
  /**
   * @deprecated Use `v` instead. Will be removed in a future version.
   */
  version?: string
}

export interface StateData {
  order: string[]
  label: {
    [key: string]: string
  }
  fullname?: {
    [key: string]: string
  }
}

export enum InputAddressValidationRule {
  ByAddressType,
  ByAddress,
}

export interface InputAddressData {
  address1: string
  address2: string
  area2: string // for en-GB
  countryCode: string
  postcode: string
  state: string
  suburb: string
}

export type MandatoryFields = Omit<InputAddressData, 'address2' | 'area2'>

export interface ProvidedAddress {
  address1: string
  address2: string
  area2: string // for en-GB
  name?: string
  postcode: string
  state: string
  suburb: string
}

export enum InputAddressDecodingStatus {
  Pristine,
  NotStarted,
  Pending,
  Resolved,
}

export interface InputAddressProps extends InputAddressLoaderOptions, CommonUIError {
  address1Label?: string
  address2InfoText?: string
  address2Label?: string
  allowedAddressType?: string[]
  autoFocus?: boolean
  showAutoCompeleteErrorTextOnly?: boolean
  componentRestrictions?: google.maps.places.ComponentRestrictions
  debounce?: number
  disabled?: boolean
  focusOnSelect?: boolean
  icon?: IconNames
  iconPosition?: InputIconPositions
  initialAddress?: ProvidedAddress | ProvidedAddress[]
  isRegions?: boolean
  label?: string
  manualAddressLabel?: string
  manualAddressLabelCaption?: string
  minSearchLength?: number
  name?: string
  onAddressBlur?: (validity: boolean) => void
  onAddressChange?: (address: InputAddressData, manuallyTouched?: boolean, validity?: boolean) => void
  onGeolocation?: ({ lat, long, placeID }: OnGeolocationArgs) => void
  onInputValueBlur?: (e: InputOnFocus) => void
  onInputValueChange?: (value: string) => void
  onManualModeChange?: (manualMode: boolean) => void
  onGeocodeResult?: (success: boolean) => void
  onManualAddressChange?: (address: InputAddressData) => void
  onManualAddressLabelClick?: () => void
  blurFieldDependencies?: string[]
  placesAutocompleteType?: string[]
  postcodeLabel?: string
  readOnly?: boolean
  searchAddressLabel?: string
  showManualAddressFieldsOnSelect?: boolean
  showManualAddressLabelInMenu?: boolean
  size?: InputSizes
  stateLabel?: string
  suburbLabel?: string
  testNameSpace?: string
  useLocalityLongName?: boolean
  validateRule?: InputAddressValidationRule
  onCustomValidation?: (parsedData: InputAddressData) => string | null
  defaultExpanded?: boolean
  optionalManualAddressFields?: string[]
  onManualErrorTrigger?: () => void // used for internal address form errors, for e.g. Google Places API
  isFullPageSuggestionsEnabled?: boolean
}

interface OnGeolocationArgs {
  lat: number | undefined
  long: number | undefined
  placeID: string
}
